import { useState, useEffect } from "react";
import { MultiSelect, DropDownList } from "@progress/kendo-react-dropdowns";
import { Input } from "@progress/kendo-react-inputs";
import { ValueEditor as DefaultValueEditor } from "react-querybuilder";
import {
  dateTimeToString,
  isNumeric,
  dateOnlyString,
  dateTimeString,
  tryParseDate,
  getJsonDateStringFromDateKey,
} from "../../lib/utils";
//import { ProDatePicker } from "../prodatepicker";
//import { ProDateTimePicker } from "../prodatetimepicker";
import { MyProDateTimePicker } from "../myprodatetimepicker";
import { MyProDatePicker } from "../myprodatepicker";
import de from "date-fns/esm/locale/de/index.js";

export const QueryValueEditor = (props) => {
  const { fieldData, value, operator, handleOnChange, handleSaveKey } = props;

  const [numberValueStart, setNumberValueStart] = useState(
    value != null && value != undefined && isNumeric(value.toString())
      ? value
      : 0,
  );
  const [numberValueEnd, setNumberValueEnd] = useState(
    value != null && value != undefined && isNumeric(value.toString())
      ? value
      : 0,
  );

  // const [dateValueStart, setDateValueStart] = useState(value && Array.isArray(value) && value.length > 0 ? new Date(value[0]) : new Date());
  // const [dateValueEnd, setDateValueEnd] = useState(value && Array.isArray(value) && value.length > 1 ? new Date(value[1]) : new Date());

  //const [dateTimeValueStart, setDateTimeValueStart] = useState(value && Array.isArray(value) && value.length > 0 ? new Date(value[0]) : new Date());
  //const [dateTimeValueEnd, setDateTimeValueEnd] = useState(value && Array.isArray(value) && value.length > 1 ? new Date(value[1]) : new Date());

  //console.log("QUERY VALUE EDITOR value: ", value)

  let dateValueStart = new Date(),
    dateValueEnd = new Date();
  let dateTimeValueStart = new Date(),
    dateTimeValueEnd = new Date();

  if (fieldData.DataTypeId == 4) {
    //Date field
    if (value) {
      if (Array.isArray(value) && value.length > 0) {
        dateValueStart = tryParseDate(value[0]);

        if (value.length > 1) dateValueEnd = tryParseDate(value[1]);
      } else {
        dateValueStart = tryParseDate(value);
        dateValueEnd = new Date();
      }
    }
  } else if (fieldData.DataTypeId == 5) {
    //DateTime field
    if (value) {
      if (Array.isArray(value) && value.length > 0) {
        dateTimeValueStart = tryParseDate(value[0]);

        if (value.length > 1) dateTimeValueEnd = tryParseDate(value[1]);
      } else {
        dateTimeValueStart = tryParseDate(value);
        dateTimeValueEnd = new Date();
      }
    }
  }

  useEffect(() => {
    //when a rule is created, operator changes or field changes
    //when a rule is added, put False if bool, today if 4 and now if 5
    if (fieldData.DataTypeId == 1 && value == "") handleOnChange("False");
    else if (fieldData.DataTypeId == 2) {
      if (value == "") {
        //field has changed to become the #
        handleOnChange("0");
        setNumberValueStart(0);
        setNumberValueEnd(0);
      } else {
        //operator has changed => value exists
        if (operator == "between") {
          //i moved to between => was single because between is the only operator who's array but better to include the extra test in case we add more 2 values operators
          if (
            !Array.isArray(value)
          ) //the else is not needed because i moved for ex from between to not between => keep the pickers and values the same
          {
            handleOnChange([value, "0"]);
            setNumberValueEnd(0);
          }
        } else {
          //maybe i am coming from between
          if (Array.isArray(value)) {
            handleOnChange(value[0]);
            setNumberValueEnd(0);
          }
          //else no need to do anything because i moved for ex. from < to >
        }
      }
    } else if (fieldData.DataTypeId == 4) {
      if (value == "" || value == null) {
        if (operator == "between") {
          //field has changed to become the DT
          handleOnChange([
            dateOnlyString(new Date()),
            dateOnlyString(new Date()),
          ]);
        } else {
          //field has changed to become the DT
          handleOnChange(dateOnlyString(new Date()));
        }
      } else {
        //operator has changed => value exists
        if (operator == "between") {
          //i moved to between => was single because between is the only operator who's array but better to include the extra test in case we add more 2 values operators
          if (
            !Array.isArray(value)
          ) //the else is not needed because i moved for ex from between to not between => keep the pickers and values the same
          {
            handleOnChange([value, dateOnlyString(new Date())]);
          }
        } else {
          //maybe i am coming from between
          if (Array.isArray(value)) {
            handleOnChange(value[0]);
          }
          //else no need to do anything because i moved for ex. from < to >
        }
      }
    } else if (fieldData.DataTypeId == 5) {
      if (value == "" || value == null) {
        if (operator == "between") {
          //field has changed to become the DT
          handleOnChange([
            dateTimeString(new Date()),
            dateTimeString(new Date()),
          ]);
        } else {
          //field has changed to become the DT
          handleOnChange(dateTimeString(new Date()));
        }
      } else {
        //operator has changed => value exists
        if (operator == "between") {
          //i moved to between => was single because between is the only operator who's array but better to include the extra test in case we add more 2 values operators
          if (!Array.isArray(value)) {
            handleOnChange([value, dateTimeString(new Date())]);
          }
        } else {
          //maybe i am coming from between
          if (Array.isArray(value)) {
            handleOnChange(value[0]);
          }
          //else no need to do anything because i moved for ex. from < to >
        }
      }
    }
  }, [fieldData.Id, operator]);

  useEffect(() => {
    if (fieldData.DataTypeId == 2) {
      if (value == "") {
        setNumberValueStart(value[0]);
        setNumberValueEnd(value[1]);
      } else {
        if (operator == "between") {
          //i am sure it is an array
          //handleOnChange(value);
          setNumberValueStart(value[0]);
          setNumberValueEnd(value[1]);
        } else {
          //handleOnChange(value);
          setNumberValueStart(value);
          setNumberValueEnd(value);
        }
      }
    }
    // else if (fieldData.DataTypeId == 4)
    // {
    //     //console.log("DD DTTT", operator, value, dateValueStart, dateValueEnd)

    //     if (value == "")
    //     {
    //         if (operator == "between")
    //         {
    //             setDateValueStart(new Date());
    //             setDateValueEnd(new Date());
    //         }
    //         else
    //         {
    //             setDateValueStart(new Date());
    //             setDateValueEnd(new Date());
    //         }
    //     }
    //     else
    //     {
    //         if (operator == "between")
    //         {
    //             setDateValueStart(getDateFromStringWithLeadingZeros(value[0].toString()));
    //             setDateValueEnd(getDateFromStringWithLeadingZeros(value[1].toString()));
    //         }
    //         else
    //         {
    //             //field has changed to become the DT
    //             //handleOnChange(value);
    //             setDateValueStart(getDateFromStringWithLeadingZeros(value.toString()));
    //             setDateValueEnd(getDateFromStringWithLeadingZeros(value.toString()));
    //         }
    //     }
    // }
    // else if (fieldData.DataTypeId == 5)
    // {
    //     //console.log("DD DTTT", operator, value, dateTimeValueStart, dateTimeValueEnd)

    //     if (value == "")
    //     {
    //         if (operator == "between")
    //         {
    //             setDateTimeValueStart(new Date());
    //             setDateTimeValueEnd(new Date());
    //         }
    //         else
    //         {
    //             setDateTimeValueStart(new Date());
    //             setDateTimeValueEnd(new Date());
    //         }
    //     }
    //     else
    //     {
    //         if (operator == "between")
    //         {
    //             //console.log("D!");
    //             //console.log(value[0]);
    //             //console.log(getDateFromStringWithLeadingZeros(value[0].toString()));

    //             ////setDateTimeValueStart(getDateFromStringWithLeadingZeros(value[0].toString()));
    //             ////setDateTimeValueEnd(getDateFromStringWithLeadingZeros(value[1].toString()));
    //             setDateTimeValueStart(new Date(value[0]));
    //             setDateTimeValueEnd(new Date(value[1]));
    //         }
    //         else
    //         {
    //             //field has changed to become the DT
    //             //handleOnChange(value);
    //             ////setDateTimeValueStart(getDateFromStringWithLeadingZeros(value.toString()));
    //             ////setDateTimeValueEnd(getDateFromStringWithLeadingZeros(value.toString()));
    //             setDateTimeValueStart(new Date(value));
    //             setDateTimeValueEnd(new Date(value));
    //         }
    //     }
    // }
  }, [value]);

  const getDateFromStringWithLeadingZeros = (s) => {
    //input: date or datetime string
    //handles the problem when i type in datepicker or datetimepicker; when i edit the year, for example i start typing 2
    //normally the year is 0002 but when the date string is passed to new Date(), the year becomes 2002 instead of 0002
    //this function sets the year correctly to 0002
    //NB: the month separator MUST BE - or / or . or space
    s = s.toString();

    let y = 0;

    let i = s.indexOf("-");
    if (i <= 0) {
      i = s.indexOf("/");
      if (i <= 0) {
        i = s.indexOf(".");
        if (i <= 0) {
          i = s.indexOf(" ");
          if (i <= 0) return new Date(s);
        }
      }
    }

    //get the number befire the separator
    y = parseInt(s.substring(0, i));

    let sCloned = s;
    if (i == 1) sCloned = "200" + s;
    else if (i == 2) sCloned = "20" + s;
    else if (i == 3) sCloned = "2" + s;

    let rCloned = new Date(sCloned);

    let r = new Date(
      2000,
      rCloned.getMonth(),
      rCloned.getDate(),
      rCloned.getHours(),
      rCloned.getMinutes(),
      rCloned.getSeconds(),
    );

    r.setFullYear(y);

    return r;
  };

  /*multi-select*/
  const handleOnMultiSelectChange = (e) => {
    let arr = e.value;

    if (!arr || arr.length == 0) {
      handleOnChange("");
    } else {
      let result = "";
      for (let v in arr) result += arr[v].Id + ",";

      handleOnChange(result.substring(0, result.length - 1));
    }
  };

  const [filteredData, setFilteredData] = useState(fieldData.Values);

  const handleFilterChange = (event) => {
    const filter = event.filter.value.toLowerCase();

    const newData = fieldData.Values.filter((item) =>
      item.Title.toLowerCase().includes(filter),
    );

    setFilteredData(newData);
  };
  /*multi-select*/

  //console.log("EDITOR RERE", value, numberValueStart, numberValueEnd, dateTimeValueStart, dateTimeValueEnd)
  if (operator == "null" || operator == "notNull") return null;

  if (fieldData.IsLookup == true) {
    let values = [];
    if (value) {
      let idsArr = value.split(",");
      for (let i in idsArr) {
        let field = fieldData.Values.find((e) => e.Id == idsArr[i]);
        if (field) values.push({ ...field });
      }
    }

    return (
      <div style={{ display: "inline-flex", flex: 1 }}>
        <MultiSelect
          data={filteredData}
          textField="Title"
          dataItemKey="Id"
          value={values}
          onChange={handleOnMultiSelectChange}
          filterable={true}
          onFilterChange={handleFilterChange}
        />
      </div>
    );
  } else if (fieldData.DataTypeId == 1) //bool
  {
    let _value = { id: "False", title: "False" };
    if (value == "True") _value = { id: "True", title: "True" };

    return (
      <div style={{ display: "inline-flex", flex: 1 }}>
        <DropDownList
          data={[
            { id: "True", title: "True" },
            { id: "False", title: "False" },
          ]}
          textField="title"
          dataItemKey="id"
          value={_value}
          onChange={(e) => handleOnChange(e.target.value.id)}
        />
      </div>
    );
  } else if (fieldData.DataTypeId == 2) //number
  {
    if (operator == "between")
      return (
        <div style={{ display: "inline-flex", flex: 1 }}>
          <Input
            type={"number"}
            onChange={(e) => {
              let nb = e.value;

              //if (date != null && date != undefined && date != "" && date instanceof Date)
              handleOnChange([nb.toString(), value[1]]);

              setNumberValueStart(nb);
            }}
            value={numberValueStart}
            autoFocus
          />
          <Input
            type={"number"}
            onChange={(e) => {
              let nb = e.value;

              //if (date != null && date != undefined && date != "" && date instanceof Date)
              handleOnChange([value[0], nb.toString()]);

              setNumberValueEnd(nb);
            }}
            value={numberValueEnd}
            style={{ marginLeft: 12 }}
            autoFocus
          />
        </div>
      );
    else
      return (
        <div style={{ display: "inline-flex", flex: 1 }}>
          <Input
            type="number"
            onChange={(e) => {
              let nb = e.value;

              //if (date != null && date != undefined && date != "" && date instanceof Date)
              handleOnChange(nb.toString());

              setNumberValueStart(nb);
            }}
            value={numberValueStart}
            autoFocus
          />
        </div>
      );
  } else if (fieldData.DataTypeId == 4) //date
  {
    if (operator == "between")
      return (
        <div
          className="query-value-editor query-value-editor-date-range"
          style={{ display: "inline-flex", flex: 1 }}
        >
          <MyProDatePicker
            showRanges={true}
            onChange={(e) => {
              handleOnChange([dateOnlyString(e.value), value[1]]);
            }}
            onDateKeySelected={(item) => {
              if (item.isRange) {
                let sDate = item.value[0];
                let eDate = item.value[1];

                handleOnChange([dateOnlyString(sDate), dateOnlyString(eDate)]);
              } else {
                // const currentEnd = Array.isArray(value) ? value[1] : dateTimeString(new Date());
                // handleOnChange([dateTimeString(item.value), currentEnd]);
                handleOnChange([dateOnlyString(item.value), value[1]]);
              }

              handleSaveKey(item.Id, props.path);
            }}
            value={dateValueStart}
            id={fieldData.Id}
          />
          <MyProDatePicker
            showRanges={true}
            onChange={(e) => {
              handleOnChange([value[0], dateOnlyString(e.value)]);
            }}
            onDateKeySelected={(item) => {
              if (item.isRange) {
                let sDate = item.value[0];
                let eDate = item.value[1];

                handleOnChange([dateOnlyString(sDate), dateOnlyString(eDate)]);
              } else {
                handleOnChange([value[0], dateOnlyString(item.value)]);
                // const currentStart = Array.isArray(value) ? value[0] : dateTimeString(new Date());
                // handleOnChange([currentStart, dateTimeString(item.value)]);
              }

              handleSaveKey(item.Id, props.path);
            }}
            value={dateValueEnd}
            id={fieldData.Id}
          />
        </div>
      );
    else
      return (
        <div style={{ display: "inline-flex", flex: 1 }}>
          <MyProDatePicker
            onChange={(e) => {
              handleOnChange(dateOnlyString(e.value));
            }}
            onDateKeySelected={(item) => {
              handleOnChange(dateOnlyString(item.value));
              handleSaveKey(item.Id, props.path);
            }}
            value={dateValueStart}
            id={fieldData.Id}
          />
        </div>
      );
  } else if (fieldData.DataTypeId == 5) //datetime
  {
    if (operator == "between")
      return (
        <div
          className="query-value-editor query-value-editor-datetime-range"
          style={{ display: "inline-flex", flex: 1 }}
        >
          <MyProDateTimePicker
            showRanges={true}
            onChange={(e) => {
              handleOnChange([dateTimeString(e.value), value[1]]);
            }}
            onDateKeySelected={(item) => {
              if (item.isRange) {
                let sDate = item.value[0];
                let eDate = item.value[1];
                handleOnChange([dateTimeString(sDate), dateTimeString(eDate)]);
              } else {
                // const currentEnd = Array.isArray(value) ? value[1] : dateTimeString(new Date());
                // handleOnChange([dateTimeString(item.value), currentEnd]);
                handleOnChange([dateTimeString(item.value), value[1]]);
              }

              handleSaveKey(item.Id, props.path);
            }}
            value={dateTimeValueStart}
          />
          <MyProDateTimePicker
            showRanges={true}
            onChange={(e) => {
              handleOnChange([value[0], dateTimeString(e.value)]);
            }}
            onDateKeySelected={(item) => {
              if (item.isRange) {
                let sDate = item.value[0];
                let eDate = item.value[1];

                handleOnChange([dateTimeString(sDate), dateTimeString(eDate)]);
              } else {
                // const currentStart = Array.isArray(value) ? value[0] : dateTimeString(new Date());
                // handleOnChange([currentStart, dateTimeString(item.value)]);
                handleOnChange([value[0], dateTimeString(item.value)]);
              }

              handleSaveKey(item.Id, props.path);
            }}
            value={dateTimeValueEnd}
          />
        </div>
      );
    else
      return (
        <div style={{ display: "inline-flex", flex: 1 }}>
          <MyProDateTimePicker
            showRanges={false}
            onChange={(e) => {
              handleOnChange(dateTimeString(e.value));
            }}
            onDateKeySelected={(item) => {
              handleOnChange(dateTimeString(item.value));
              handleSaveKey(item.Id, props.path);
            }}
            value={dateTimeValueStart}
          />
        </div>
      );
  } else if (fieldData.DataTypeId == 3) {
    return (
      <Input
        type={props.inputType || "text"}
        value={value || ""}
        autoFocus
        onChange={(e) => handleOnChange(e.value)}
      />
    );
  } else
    return (
      <DefaultValueEditor
        {...props}
        inputProps={{
          autoFocus: true,
        }}
      />
    );
};
